import React from "react";

const Exit = ({ color, height, width }) => (
<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" style={{minWidth: "14px"}}>
  <path d="M6.75 13.1839V11.719H12V1.46488H6.75V0H12C12.4125 0 12.7656 0.143436 13.0594 0.430309C13.3531 0.717181 13.5 1.06204 13.5 1.46488V11.719C13.5 12.1219 13.3531 12.4667 13.0594 12.7536C12.7656 13.0405 12.4125 13.1839 12 13.1839H6.75ZM5.25 10.2542L4.21875 9.19213L6.13125 7.32441H0V5.85952H6.13125L4.21875 3.9918L5.25 2.92976L9 6.59197L5.25 10.2542Z" fill="white"/>
</svg>
);

export default Exit;
